import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_962fea69: FaireBrandEntity = {
  token: "b_962fea69",
  type: "brand",
  name: "Anna Beck Jewelry | Handmade in Bali",
  avatarUrl:
    "https://cdn.faire.com/fastly/a34211d60bfb17b326a47228afa45224f4b63df6ef04c9b687f681357414c254.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e5bead03af376b8b9969be122e6714aaac696404db3ac17f4aeb07320d95eb52.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a34211d60bfb17b326a47228afa45224f4b63df6ef04c9b687f681357414c254.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e5bead03af376b8b9969be122e6714aaac696404db3ac17f4aeb07320d95eb52.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "At Anna Beck, every piece of jewelry is a tribute to connection, across cultures, generations, and moments in time. Our designs are handcrafted in Bali by skilled artisans who practice traditional techniques passed down through generations. With each piece, we honor their heritage and preserve the beauty of their craft.\n\nRooted in the spirit of collaboration, Anna Beck is more than adornment, it’s a celebration of intentional design and global artistry. We believe in the power of jewelry to spark connection, express gratitude, and create change. Through ongoing philanthropic partnerships and mindful production, we’re committed to making a meaningful impact - one piece at a time.\n\nEach time you showcase Anna Beck, we hope it becomes a reminder: to slow down, to give thanks, and to carry beauty into the everyday. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:05.759Z",
    importedBy: "entity-db-cli",
  },
};
